<ng-container *transloco="let convert;">
  @if (details$ | async; as vehicle) {
    <section class="sell-vehicle-detail">
      @if (showHeading) {
        <h3 class="text-uppercase fw-bold h5">{{convert('sellModule.details.vehicleDetail.vehicleDetails')}}</h3>
      }
      <div class="row">
        <div class="col-sm-4">
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.seller')}}" [value]="vehicle.seller"></app-datalist-item>
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.odometer')}}" [value]="(vehicle.odometer | number) + ' ' + vehicleDetailTranslations.distanceUnit"></app-datalist-item>
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.vehicleLocation')}}" [value]="vehicle.location"></app-datalist-item>
        </div>
        <div class="col-sm-4">
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.distance')}}" [value]="vehicle.distance + ' ' + vehicleDetailTranslations.distanceUnit"></app-datalist-item>
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.titleState')}}" [value]="vehicle.titleState"></app-datalist-item>
          @if (isMsrpEnabled) {
            <app-datalist-item label="MSRP" [value]="vehicle.msrp"></app-datalist-item>
          }
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.type')}}" [value]="vehicle.type"></app-datalist-item>
        </div>
        <div class="col-sm-4">
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.exterior')}}" [value]="vehicle.exterior"></app-datalist-item>
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.interior')}}" [value]="vehicle.interior"></app-datalist-item>
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.hits')}}" [value]="vehicle.hits | number"></app-datalist-item>
        </div>
      </div>
      <div class="row mt-1 pt-3 mb-2">
        <div class="col">
          <div class="border-top"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-8">
          <app-datalist-item label="{{convert('sellModule.details.vehicleDetail.sellerComments')}}">
            <span
              class="me-2 seller-comments__comment"
              [ngClass]="{'paid-comment':  vehicle.sellerComments !== 'N/A'}"
              >
              {{ vehicle.sellerComments }}
            </span>
          </app-datalist-item>
        </div>
      </div>
    </section>
  }
</ng-container>
